import React, { useContext } from 'react'
import styled from 'styled-components'
import { LayoutContext } from '../../contexts'
import { useGlobal } from '../../hooks/useGlobal'
import RichText from '../RichText'
import { SiteLink } from '../shared/SiteLink'

const AnnouncementBlackFriday = () => {
  const { node_locale, currency } = useContext(LayoutContext)
  const {
    blackFriday: {
      announcementBarBgColor,
      announcementBarTextColor,
      announcementItemBlackFriday2022,
      announcementBarLinkBlackFriday2022,
    },
  } = useGlobal(['blackFriday'], node_locale)

  return (
    <Container
      bgColor={announcementBarBgColor}
      textColor={announcementBarTextColor}
    >
      <AnnouncementDiv>
        {announcementBarLinkBlackFriday2022 ? (
          <Link to={announcementBarLinkBlackFriday2022?.target?.slug}>
            {[...Array(5)].map((i) => (
              <RichTextContainer key={i}>
                <RichText json={announcementItemBlackFriday2022} />
              </RichTextContainer>
            ))}
          </Link>
        ) : (
          <NoLink>
            {[...Array(5)].map((i) => (
              <RichTextContainer key={i}>
                <RichText json={announcementItemBlackFriday2022} />
              </RichTextContainer>
            ))}
          </NoLink>
        )}
      </AnnouncementDiv>
    </Container>
  )
}

const Container = styled.div`
  height: ${(props) => props.theme.announcementHeight.mobile};
  color: ${(props) => props.textColor || '#f1f1f1'};
  background-color: ${(props) => props.bgColor || '#f1f1f1'};
  overflow: hidden;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    height: ${(props) => props.theme.announcementHeight.desktop};
  }

  p {
    font-size: ${(props) => props.theme.fontSize.m23};
    padding: ${(props) => props.theme.space.marginMobile / 4}vw 0;
    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      font-size: ${(props) => props.theme.fontSize.d12};
      padding: ${(props) => props.theme.space.marginDesktop / 3}vw 0;
    }
  }
`

const AnnouncementDiv = styled.div`
  display: flex;
  align-items: center;
  height: ${(props) => props.theme.announcementHeight.mobile};

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    height: ${(props) => props.theme.announcementHeight.desktop};
  }
`

const Link = styled(SiteLink)`
  display: flex;
  align-items: center;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    margin: 0 1.5vw;
  }
`

const NoLink = styled.div`
  display: flex;
  align-items: center;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    margin: 0 1.5vw;
  }
`

const RichTextContainer = styled.div`
  white-space: nowrap;
  padding-right: 64px;
  @keyframes marquee {
    0% {
      transform: translate(0%);
    }
    100% {
      transform: translate(-100%);
    }
  }
  animation: marquee 15s linear both infinite;
  animation-delay: 0s;
`

export default AnnouncementBlackFriday
